import { AuthActionPayload } from "../../auth-slice/types"
import { AuthenticatedResponse, SpecificNotificationRequest } from "./types"
import { toSubscriptionState } from "../../../types"

export const transformAuthenticatedResponse = (response: AuthenticatedResponse,): AuthActionPayload => {
  response.data.user.uuid = response.data.uuid
  return {
    user: response.data.user,
    token: response.data.token,
    subscription: response.data.subscription ? {
      ...response.data.subscription,
      state: toSubscriptionState(response.data.subscription.state),
    } : undefined,
  }
}
